import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type WorkflowRunKindsFetchedPayload = LabeledValuePayload[];

export type WorkflowRunKindsFetchedAction = {
	type: 'WORKFLOW_RUN_KINDS_FETCHED';
	payload: WorkflowRunKindsFetchedPayload;
};

export default (payload: WorkflowRunKindsFetchedPayload): WorkflowRunKindsFetchedAction => ({
	type: 'WORKFLOW_RUN_KINDS_FETCHED',
	payload,
});
